import { render } from "./FormInput.vue?vue&type=template&id=2bf76893"
import script from "./FormInput.vue?vue&type=script&lang=js"
export * from "./FormInput.vue?vue&type=script&lang=js"
script.render = render

export default script